"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SurveyBayResponse = void 0;
var firebaseTimestampToDate_1 = require("@swing-therapeutics/swingcore/dist/utils/firebase/firebaseTimestampToDate");
var utils_1 = require("../utils");
var lodash_1 = require("lodash");
var types_1 = require("../types");
var SurveyBayResponse = /** @class */ (function () {
    function SurveyBayResponse() {
    }
    SurveyBayResponse.fromParams = function (props) {
        var _a, _b;
        var response = new SurveyBayResponse();
        response.id = props === null || props === void 0 ? void 0 : props.id;
        response.surveyBayKey = props === null || props === void 0 ? void 0 : props.surveyBayKey;
        response.userUID = props === null || props === void 0 ? void 0 : props.userUID;
        response.assigned = firebaseTimestampToDate_1.firebaseTimestampToDate((_a = props === null || props === void 0 ? void 0 : props.assigned) !== null && _a !== void 0 ? _a : new Date());
        response.started = firebaseTimestampToDate_1.firebaseTimestampToDate(props === null || props === void 0 ? void 0 : props.started);
        response.completed = firebaseTimestampToDate_1.firebaseTimestampToDate(props === null || props === void 0 ? void 0 : props.completed);
        response.expires = firebaseTimestampToDate_1.firebaseTimestampToDate(props === null || props === void 0 ? void 0 : props.expires);
        response.created = firebaseTimestampToDate_1.firebaseTimestampToDate(props === null || props === void 0 ? void 0 : props.created);
        response.status = (_b = props === null || props === void 0 ? void 0 : props.status) !== null && _b !== void 0 ? _b : types_1.SurveyStatus.ASSIGNED;
        response.questions = props === null || props === void 0 ? void 0 : props.questions;
        response.score = props === null || props === void 0 ? void 0 : props.score;
        response.scoreNote = props === null || props === void 0 ? void 0 : props.scoreNote;
        response.isEligibilitySurvey = props === null || props === void 0 ? void 0 : props.isEligibilitySurvey;
        response.name = props === null || props === void 0 ? void 0 : props.name;
        response.workflowDocID = props === null || props === void 0 ? void 0 : props.workflowDocID;
        response.therapyWeek = props === null || props === void 0 ? void 0 : props.therapyWeek;
        response.failReason = props === null || props === void 0 ? void 0 : props.failReason;
        response.workflowType = props.workflowType;
        if (props.completedMessage) {
            response.completedMessage = props.completedMessage;
        }
        if (props.runCheckIndexes) {
            response.runCheckIndexes = props.runCheckIndexes;
        }
        return response;
    };
    SurveyBayResponse.fromFirestore = function (docRef) {
        return SurveyBayResponse.fromParams(docRef.data());
    };
    SurveyBayResponse.prototype.start = function () {
        this.status = types_1.SurveyStatus.IN_PROGRESS;
        this.started = new Date();
    };
    SurveyBayResponse.prototype.complete = function () {
        this.status = types_1.SurveyStatus.COMPLETED;
        this.completed = new Date();
    };
    SurveyBayResponse.prototype.expire = function () {
        this.status = types_1.SurveyStatus.EXPIRED;
    };
    SurveyBayResponse.prototype.query = function () {
        return utils_1.getSurveyBayResponses(this.userUID).doc(this.id);
    };
    SurveyBayResponse.prototype.data = function () {
        var data = {
            id: this.id,
            name: this.name,
            workflowDocID: this.workflowDocID,
            surveyBayKey: this.surveyBayKey,
            userUID: this.userUID,
            expires: this.expires,
            assigned: this.assigned,
            created: this.created,
            started: this.started,
            completed: this.completed,
            status: this.status,
            questions: this.questions,
            score: this.score,
            scoreNote: this.scoreNote,
            isEligibilitySurvey: this.isEligibilitySurvey,
        };
        return lodash_1.omitBy(data, lodash_1.isUndefined);
    };
    SurveyBayResponse.prototype.persist = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.query().set(this.data(), { merge: true })];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return SurveyBayResponse;
}());
exports.SurveyBayResponse = SurveyBayResponse;
